<div class="w-auto">
  <div class="row w-auto align-items-center">
    <div class="col">
      <input
        pInputText
        fluid
        i18n-placeholder="@@word"
        placeholder="Wort"
        [(ngModel)]="this.wordInput"
        >
    </div>
    <div class="col">
      <input
        pInputText
        fluid
        i18n-placeholder="@@replacement"
        placeholder="Ersatz"
        [(ngModel)]="this.replacementInput"
        >
    </div>
  </div>
  <p-button
    styleClass="mt-2"
    size="small"
    severity="primary"
    [disabled]="this.isConfigInValid()"
    (onClick)="this.addWordReplace()"
    >
    <i class="ri-add-line"></i>
    <span i18n="@@add">Hinzufügen</span>
  </p-button>
  @if (this.botConfig.wordReplacements.length > 0) {
    <p-table
      [value]="this.botConfig.wordReplacements"
      [rowHover]="true"
      styleClass="p-datatable-sm mt-3"
      >
      <ng-template pTemplate="header">
        <tr>
          <th i18n="@@word">Wort</th>
          <th i18n="@@replacement">Ersatz</th>
          <th
            class="text-end"
            style="width: 6rem"
            i18n="@@actions"
          >Aktionen</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-wordReplacement
        let-i="rowIndex"
        >
        <tr>
          <td>{{ wordReplacement.word }}</td>
          <td>{{ wordReplacement.replacement }}</td>
          <td class="text-end">
            <p-button
              size="small"
              severity="danger"
              [outlined]="true"
              icon="ri-close-line"
              i18n-ariaLabel="@@delete-word-replacement"
              ariaLabel="Wortersetzung löschen"
              (onClick)="this.removeWordReplace(i)"
              />
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
